/**
 * Scroll Utilities Component
 * Provides smooth scrolling functionality
 */

'use strict';

var twentyninetimesCustomForm = twentyninetimesCustomForm || {};

twentyninetimesCustomForm.ScrollUtils = {
    /**
     * Get header height for scroll offset calculation
     * @returns {number} Header height in pixels
     */
    getHeaderHeight: function() {
        return window.innerWidth > 960 ? 150 : 120;
    },

    /**
     * Smoothly scroll to a field or container
     * @param {HTMLElement} elm - Element to scroll to
     */
    scrollToElement: function(elm) {
        const scrollTop = Math.max(
            window.pageYOffset, 
            document.documentElement.scrollTop, 
            document.body.scrollTop
        );
        const headerHeight = this.getHeaderHeight();
        const elmScrollTop = scrollTop + elm.getBoundingClientRect().top - headerHeight;
        
        this.scrollTo(elmScrollTop, 500);
    },

    /**
     * Smooth scroll utility with easing animation
     * @param {number} to - Target scroll position
     * @param {number} duration - Animation duration in ms
     */
    scrollTo: function(to, duration) {
        const element = document.scrollingElement || document.documentElement;
        const start = element.scrollTop;
        const change = to - start;
        const startDate = +new Date();

        // Easing function for smooth animation
        function easeInOutQuad(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        }

        // Animate scroll
        function animateScroll() {
            const currentDate = +new Date();
            const currentTime = currentDate - startDate;
            element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
            
            if (currentTime < duration) {
                requestAnimationFrame(animateScroll);
            } else {
                element.scrollTop = to;
            }
        }

        animateScroll();
    }
};